import { AccessDenied } from "@/components/shared/AccessDenied";
import { NotFound } from "@/components/shared/NotFound";
import { ADMIN_ROLES } from "@/lib/constants/roles";
import { Navigate, Outlet, createFileRoute } from "@tanstack/react-router";
import { useAuth } from "../contexts/AuthContext";

function AdminLayout() {
  const { user, isAuthenticated, isPending } = useAuth();

  if (isPending) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto" />
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" search={{ redirect: "/admin" }} />;
  }

  // Allow all admin roles to view admin pages
  if (!user?.role || !ADMIN_ROLES.includes(user.role)) {
    return <AccessDenied description="You need admin privileges to access this page." />;
  }

  return <Outlet />;
}

function AdminErrorComponent() {
  return (
    <NotFound
      title="Something went wrong"
      description="The resource you're looking for could not be found or is invalid."
    />
  );
}

export const Route = createFileRoute("/admin")({
  component: AdminLayout,
  notFoundComponent: NotFound,
  errorComponent: AdminErrorComponent,
});
